module.exports = __webpack_public_path__ + "static/media/A6.b7e6c16d.jpg";